<template>
  <div class="z-card pix-card">
    <z-title size="small" class="spacer-bottom-l">
      Pague através do QR Code ou código
    </z-title>

    <div class="row spacer-bottom-l pix-card__content">
      <div class="col-md-6">
        <z-text class="spacer-bottom-s">
          Abra o aplicativo do seu banco ou carteira digital e escaneie o QR
          Code, ou clique no botão abaixo para copiar o código e realizar o
          pagamento.
        </z-text>

        <z-text>
          Ao optar pelo Pix, a transação será processada instantaneamente e o
          valor será debitado diretamente do seu saldo no banco ou na carteira
          digital.
        </z-text>
      </div>
      <div v-if="!hasQRCodeError">
        <img
          class="pix-card__qr-code-image"
          :src="dataURL"
          alt="QR Code"
        >
      </div>
      <div v-else class="z-text z-text--small pix-card__qr-code-image__error">
        Falha ao gerar o QR Code. Clique no botão abaixo para copiar o código
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 pix-card__footer">
        <button
          class="z-button z-button--primary spacer-bottom-m pix-card__button js-clipboard-btn"
          v-clipboard:copy="qrCode"
          v-clipboard:success="copySuccess"
        >
          Copiar código
        </button>
        <div>
          O código gerado é válido até {{ expirationDate }} às
          {{ expirationTime }}.
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.pix-card {
  margin-bottom: var(--space-extra-large);
  margin-top: var(--space-extra-large);
  text-align: center;
}

.pix-card__footer {
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 100%;
}

.pix-card__button {
  width: 225px;
}

.pix-card__content {
  align-items: center;
  display: flex;
  justify-content: space-between;

  @media (max-width: $screen-md-min) {
    flex-direction: column;
  }
}

.pix-card__qr-code-image {
  width: 225px;
}

.pix-card__qr-code-image__error {
  align-items: center;
  border: 1px solid var(--color-alpha-gray-032);
  display: flex;
  height: 200px;
  justify-content: center;
  padding: var(--space-micro);
  width: 200px;
}
</style>

<script>
import QRCode from 'qrcode';

export default {
  props: {
    qrCode: {
      type: String,
      required: true,
    },
    callbackClipboard: {
      type: Function,
      required: true,
    },
    expirationAt: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dataURL: '',
      hasQRCodeError: false,
    };
  },
  computed: {
    expirationDate() {
      const formattedDate = new Date(this.expirationAt);
      const options = { day: '2-digit', month: '2-digit', year: 'numeric' };

      return formattedDate.toLocaleDateString('pt-BR', options);
    },
    expirationTime() {
      const formattedDate = new Date(this.expirationAt);
      const options = { hour: '2-digit', minute: '2-digit' };

      return formattedDate.toLocaleTimeString('pt-BR', options);
    },
  },
  methods: {
    copySuccess() {
      this.callbackClipboard();
    },
    generatedQRCode() {
      QRCode.toDataURL(this.qrCode, { errorCorrectionLevel: 'L' })
        .then((url) => {
          this.dataURL = url;
        })
        .catch(() => {
          this.hasQRCodeError = true;
        });
    },
  },
  mounted() {
    this.generatedQRCode();
  },
};
</script>
